import React from 'react';
import { Outlet } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Footer from '../Footer';
import Header from '../Header';

export default function Layout() {
  return (
    <>
      <Helmet>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Organization",
              "name": "Mercury Healthcare",
              "url": "https://www.mercuryhc.com",
              "logo": "https://www.mercuryhc.com/images/Mercury%20logo%20200x50.png",
              "email": "info@mercuryhc.com",
              "telephone": "+91-9825025940",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "44 Siddhi Industrial Park, Waghodia",
                "addressRegion": "Gujarat",
                "addressCountry": "IN"
              }
            })
          }}
        />
      </Helmet>

      <Header
        logoSrc="/images/Mercury logo 200x50.png"
        variant="cs_heading_color"
      />

      <Outlet />

      <Footer />
    </>
  );
}
